export default function ({state, getters, commit, dispatch}, vm) {
  vm.$confirm('Удалить платеж по сертификату?', 'Удаление платежа №', {
    confirmButtonText: 'Удалить',
    cancelButtonText: 'Отмена',
    type: 'info'
  }).then(() => {
    commit('loading', true);
    remove(state.Id)
      .then(() => {
        window.app.$notify.success({
          message: 'Платёж удален',
        });
        dispatch('certificates/item/create', {type: 'edit', id: getters.data.CertificateId}, {root: true});
        commit('loading');
      })
      .catch(err => {
        if (err.fiscal) {
          vm
            .$confirm(err.text, 'Возникла ошибка', {
              confirmButtonText: 'Удалить',
              cancelButtonText: 'Отмена',
              type: 'info'
            })
            .then(() => {
              remove(state.Id, {fiscal: true})
                .then(() => {
                  window.app.$notify.success({
                    message: 'Платёж удален',
                  });
                  dispatch('certificates/item/create', {type: 'edit', id: getters.data.CertificateId}, {root: true});
                  commit('loading');
                })
                .catch(err => {
                  commit('loading');
                  vm.$notify.error(err.text);
                })
            }).catch(e => {
            commit('loading');
          });
        }
      });
  }).catch(e => {
  });
}

function remove(id, d) {
  return new Promise((resolve, reject) => {
    const fiscal = d ? !!d.fiscal : false;
    axios({
      method: 'post',
      url: '/tourclient/payment/deletePayment?id=' + id,
      data: `id=${id}&UnfastenFiskalDocuments=${fiscal}`,
      requestId: '/tourclient/payment/deletePayment'
    }).then(({data}) => {
      if (data.ResultQueryInfo && data.ResultQueryInfo.UserMessages) {
        const err = {text: data.ResultQueryInfo.UserMessages};
        if (data.UnfastenFiskalDocuments) {
          err.fiscal = true;
        }
        reject(err);
      } else {
        resolve(data);
      }
    }).catch(e => {
      reject({text: 'Ошибка при удалении платежа'});
    });
  })
}
